export default {
  title: 'Terminale',
  stats: {
    terminal_battery_level: 'Livello batteria',
    terminal_battery_state: 'Stato di ricarica',
    auto_accept_orders: 'Accetta ordini automaticamente',
  },
  auto_accept_orders_modal: {
    title: 'Sei sicuro di voler accettare gli ordini automaticamente?',
    buttons: {
      activate: 'Attiva',
      cancel: 'Annulla',
    },
  },
  feedback: {
    update_success: 'Aggiornato con successo',
    update_failed: 'Aggiornamento non riuscito. Riprova.',
  },
};
